const DEALERSHIP_AGE = [
	{ key: 0, value: '1', label: 'Less than 6 months', railsValue: 0 },
	{ key: 1, value: '2', label: 'More than 6 months', railsValue: 4 },
];

export default DEALERSHIP_AGE;
